import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValueLoadable } from 'recoil';
import getObesForCustomer from 'api/obes/getObesForCustomer';
import { AutocompleteAsync } from 'components/Form';
import { BoldSubtitle } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import checkLoadable from 'utils/recoil/checkLoadable';
export default function ChooseTag({
  setObeNumber
}) {
  const {
    customer
  } = useCurrentCustomer();
  const {
    t
  } = useTranslation();
  const obesLoadable = useRecoilValueLoadable(getObesForCustomer(customer?.id));
  const {
    contents: vehicles,
    loading
  } = checkLoadable(obesLoadable);
  const onChange = async (_event, value) => {
    if (!value) {
      setObeNumber(null);
    } else if (value?.obeNumber) {
      setObeNumber(value.obeNumber);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('transfer_tag.choose_tag_or_vehicle')), /*#__PURE__*/React.createElement(AutocompleteAsync, {
    isLoading: loading,
    onChange: onChange,
    options: vehicles?.results ?? [],
    optionLabel: ['registrationNumber', 'obeNumber'],
    placeholder: t('transfer_tag.choose_tag_or_vehicle')
  }));
}